export default "__VITE_ASSET__Z0bh15RZ__"